/* FIFA OPEN · СКО — данные турнира · сезон 2026 · формат ЧМ: 8 групп → плей-офф.
   Инфо о турнире (даты, место, приз и т.д.) перекрывается данными с бэкенда
   (/api/tournaments/active) — см. useFifaTournament.js.

   По ходу турнира: счёт в группах — rows: [имя, 'флаг Сборная', [В,Н,П,ЗМ,ПМ,О]]
   (строки сортируй по месту), плей-офф — заменяй { ph: '...' } на
   { n: 'Имя', c: 'Сборная', via: '1-е · A', g: голы, win: true }. */

export const FC_TOURNAMENT = {
  id: 'fifa-open-sko-2026',
  title: 'FIFA OPEN · СКО',
  season: '2026',
  game: 'EA SPORTS FC 26',
  platform: 'PlayStation 5',
  mode: '1 на 1 · сборные',
  status: 'Турнир завершён · чемпион — Босния',
  participants: 40,
  groupsCount: 8,
  date: '12 июля 2026',
  place: 'Спортбар SALEM · Петропавловск',
  prize: 'Кубок СКО · медали · мерч',
  regPhone: '+7 700 678 0221',
  fee: '3 000 ₸ с участника',
  format: '8 групп → плей-офф с 1/8',
  eligibility: 'Школьники и студенты',
  telegram: '@fc_sko',
  organizer: 'ОО «Ecotime» · проект «Федерация киберспорта СКО»',
  partner: 'Спортбар SALEM',
  twitchUrl: 'https://www.twitch.tv/cybersqo',
  youtubeUrl: 'https://youtube.com/@sko_esports',
};

/* ---- организаторы и спонсоры ---- */
export const FC_SPONSORS = [
  {
    name: 'ОО «Ecotime»',
    sub: 'Проект «Федерация киберспорта СКО» · организатор турнира',
    logo: '/assets/logo-federation.png',
  },
  {
    name: 'Спортбар SALEM',
    sub: 'Спонсор турнира',
    logo: '/assets/logo-salem.png',
    light: true, // логотип на белом фоне
  },
];

export const FC_STAGES = [
  { n: '01', t: 'Жеребьёвка', d: 'Проведена 12 июля · 40 участников, 8 групп, сборные разыграны', state: 'done' },
  { n: '02', t: 'Групповой этап', d: 'Сыгран · 8 групп, по два лучших вышли в плей-офф', state: 'done' },
  { n: '03', t: 'Плей-офф · 1/8 и 1/4', d: 'Сыгран · 16 участников, матчи навылет', state: 'done' },
  { n: '04', t: 'Финалы', d: 'Чемпион — Босния (Влад А.) · бронза — Египет (Арман К.)', state: 'done' },
];

export const FC_RULES = [
  'Платформа PlayStation 5 · EA SPORTS FC 26 · режим Kick-Off',
  'Играем за сборные — команды раздаёт жеребьёвка в день турнира',
  'Тайм 6 минут · обычная скорость',
  'Группы: победа — 3 очка, ничья — 1 · тай-брейк: очки → разница → личная встреча',
  'В плей-офф выходят два лучших игрока из каждой группы',
  'Плей-офф: ничья — доп. время и пенальти · 1/2 и финал — серия до 2 побед',
  'Групповые туры играются в 4 матча одновременно на столах 1–4',
  'Неявка более 10 минут — техническое поражение 0:3',
];

/* ---- участники · сборные и группы по жеребьёвке 12 июля ---- */
export const FC_PARTICIPANTS = [
  { num: 1, name: 'Аркат А.', flag: '🇭🇷', team: 'Хорватия', group: 'A' },
  { num: 2, name: 'Сын Алмаз', flag: '🇩🇪', team: 'Германия', group: 'B' },
  { num: 3, name: 'Алдияр Ш.', flag: '🇨🇦', team: 'Канада', group: 'H' },
  { num: 4, name: 'Сергей Н.', flag: '🇿🇦', team: 'ЮАР', group: 'F' },
  { num: 5, name: 'Евгений Г.', flag: '🇦🇺', team: 'Австралия', group: 'B' },
  { num: 6, name: 'Руслан Л.', flag: '🇫🇷', team: 'Франция', group: 'F' },
  { num: 7, name: 'Нурсултан Б.', flag: '🇨🇿', team: 'Чехия', group: 'D' },
  { num: 8, name: 'Ростислав Х. (GRIZZLY)', flag: '🇺🇾', team: 'Уругвай', group: 'E' },
  { num: 9, name: 'Виталий А.', flag: '🇳🇱', team: 'Нидерланды', group: 'G' },
  { num: 10, name: 'Роман И.', flag: '🇵🇾', team: 'Парагвай', group: 'F' },
  { num: 11, name: 'Жорик И.', flag: '🇳🇴', team: 'Норвегия', group: 'E' },
  { num: 12, name: 'Сергей Ш.', flag: '🇨🇼', team: 'Кюрасао', group: 'D' },
  { num: 13, name: 'Игорь Д.', flag: '🇧🇷', team: 'Бразилия', group: 'E' },
  { num: 14, name: 'Александр К.', flag: '🇯🇵', team: 'Япония', group: 'E' },
  { num: 15, name: 'Даниял А.', flag: '🇺🇿', team: 'Узбекистан', group: 'G' },
  { num: 16, name: 'Арман К.', flag: '🇪🇬', team: 'Египет', group: 'A' },
  { num: 17, name: 'Арғын Ш.', flag: '🇨🇻', team: 'Кабо-Верде', group: 'F' },
  { num: 18, name: 'Никита Л.', flag: '🇦🇹', team: 'Австрия', group: 'E' },
  { num: 19, name: 'Даниил И.', flag: '🇹🇳', team: 'Тунис', group: 'F' },
  { num: 20, name: 'Бек И.', flag: '🇧🇪', team: 'Бельгия', group: 'G' },
  { num: 21, name: 'Магомед Д.', flag: '🇨🇮', team: 'Кот-д’Ивуар', group: 'D' },
  { num: 22, name: 'Влад А.', flag: '🇧🇦', team: 'Босния и Герцеговина', group: 'H' },
  { num: 23, name: 'Кузьма А.', flag: '🇲🇦', team: 'Марокко', group: 'A' },
  { num: 24, name: 'Канат', flag: '🇵🇹', team: 'Португалия', group: 'A' },
  { num: 25, name: 'Адиль У.', flag: '🇸🇪', team: 'Швеция', group: 'H' },
  { num: 26, name: 'Асет У.', flag: '🇯🇴', team: 'Иордания', group: 'G' },
  { num: 27, name: 'Тобыл К.', flag: '🇨🇭', team: 'Швейцария', group: 'C' },
  { num: 28, name: 'Малик А.', flag: '🇪🇸', team: 'Испания', group: 'C' },
  { num: 29, name: 'Мурат Д.', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿', team: 'Шотландия', group: 'B' },
  { num: 30, name: 'Нурсултан К.', flag: '🇰🇷', team: 'Юж. Корея', group: 'H' },
  { num: 31, name: 'Алмаз З.', flag: '🇨🇴', team: 'Колумбия', group: 'D' },
  { num: 32, name: 'Максим Ш.', flag: '🇮🇷', team: 'Иран', group: 'C' },
  { num: 33, name: 'Кизат А.', flag: '🇨🇬', team: 'Конго', group: 'B' },
  { num: 34, name: 'Ахат К.', flag: '🇬🇭', team: 'Гана', group: 'C' },
  { num: 35, name: 'Улан Р.', flag: '🇦🇷', team: 'Аргентина', group: 'A' },
  { num: 36, name: 'Артур А.', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', team: 'Англия', group: 'C' },
  { num: 37, name: 'Сабит И.', flag: '🇩🇿', team: 'Алжир', group: 'H' },
  { num: 38, name: 'Егор П.', flag: '🇵🇦', team: 'Панама', group: 'B' },
  { num: 39, name: 'Арлан', flag: '🇸🇳', team: 'Сенегал', group: 'D' },
  { num: 40, name: 'Нурым К.', flag: '🇭🇹', team: 'Гаити', group: 'G' },
];

/* ---- группы · rows: [имя, 'флаг Сборная', [В,Н,П,ЗМ,ПМ,О]] · сортировка по месту ---- */
export const FC_GROUPS = [
  { id: 'A', done: true, rows: [
    ['Канат', '🇵🇹 Португалия', [3, 0, 1, 21, 8, 9]],
    ['Арман К.', '🇪🇬 Египет', [3, 0, 1, 12, 10, 9]],
    ['Улан Р.', '🇦🇷 Аргентина', [2, 1, 1, 15, 10, 7]],
    ['Кузьма А.', '🇲🇦 Марокко', [1, 0, 3, 5, 12, 3]],
    ['Аркат А.', '🇭🇷 Хорватия', [0, 1, 3, 1, 14, 1]],
  ]},
  { id: 'B', done: true, rows: [
    ['Егор П.', '🇵🇦 Панама', [4, 0, 0, 13, 3, 12]],
    ['Мурат Д.', '🏴󠁧󠁢󠁳󠁣󠁴󠁿 Шотландия', [3, 0, 1, 17, 8, 9]],
    ['Кизат А.', '🇨🇬 Конго', [2, 0, 2, 12, 7, 6]],
    ['Сын Алмаз', '🇩🇪 Германия', [1, 0, 3, 8, 20, 3]],
    ['Евгений Г.', '🇦🇺 Австралия', [0, 0, 4, 0, 12, 0]],
  ]},
  { id: 'C', done: true, rows: [
    ['Ахат К.', '🇬🇭 Гана', [4, 0, 0, 18, 4, 12]],
    ['Малик А.', '🇪🇸 Испания', [3, 0, 1, 19, 11, 9]],
    ['Артур А.', '🏴󠁧󠁢󠁥󠁮󠁧󠁿 Англия', [1, 0, 3, 10, 12, 3]],
    ['Тобыл К.', '🇨🇭 Швейцария', [1, 0, 3, 9, 11, 3]],
    ['Максим Ш.', '🇮🇷 Иран', [1, 0, 3, 3, 21, 3]],
  ]},
  { id: 'D', done: false, rows: [
    ['Алмаз З.', '🇨🇴 Колумбия', [2, 2, 0, 10, 4, 8]],
    ['Магомед Д.', '🇨🇮 Кот-д’Ивуар', [2, 2, 0, 9, 6, 8]],
    ['Арлан', '🇸🇳 Сенегал', [0, 3, 0, 6, 6, 3]],
    ['Сергей Ш.', '🇨🇼 Кюрасао', [0, 2, 2, 4, 7, 2]],
    ['Нурсултан Б.', '🇨🇿 Чехия', [0, 1, 2, 2, 8, 1]],
  ]},
  { id: 'E', done: true, rows: [
    ['Никита Л.', '🇦🇹 Австрия', [4, 0, 0, 20, 6, 12]],
    ['Александр К.', '🇯🇵 Япония', [3, 0, 1, 14, 9, 9]],
    ['Игорь Д.', '🇧🇷 Бразилия', [2, 0, 2, 13, 9, 6]],
    ['Жорик И.', '🇳🇴 Норвегия', [1, 0, 3, 4, 13, 3]],
    ['Ростислав Х. (GRIZZLY)', '🇺🇾 Уругвай', [0, 0, 4, 5, 19, 0]],
  ]},
  { id: 'F', done: true, rows: [
    ['Арғын Ш.', '🇨🇻 Кабо-Верде', [3, 1, 0, 13, 2, 10]],
    ['Руслан Л.', '🇫🇷 Франция', [1, 3, 0, 8, 5, 6]],
    ['Сергей Н.', '🇿🇦 ЮАР', [1, 2, 1, 10, 11, 5]],
    ['Даниил И.', '🇹🇳 Тунис', [1, 2, 1, 7, 8, 5]],
    ['Роман И.', '🇵🇾 Парагвай', [0, 0, 4, 0, 12, 0]],
  ]},
  { id: 'G', done: true, rows: [
    ['Асет У.', '🇯🇴 Иордания', [4, 0, 0, 13, 1, 12]],
    ['Нурым К.', '🇭🇹 Гаити', [3, 0, 1, 11, 7, 9]],
    ['Даниял А.', '🇺🇿 Узбекистан', [2, 0, 2, 8, 11, 6]],
    ['Бек И.', '🇧🇪 Бельгия', [1, 0, 3, 6, 7, 3]],
    ['Виталий А.', '🇳🇱 Нидерланды', [0, 0, 4, 0, 12, 0]],
  ]},
  { id: 'H', done: true, rows: [
    ['Влад А.', '🇧🇦 Босния и Герцеговина', [3, 1, 0, 20, 7, 10]],
    ['Нурсултан К.', '🇰🇷 Юж. Корея', [3, 1, 0, 15, 7, 10]],
    ['Алдияр Ш.', '🇨🇦 Канада', [1, 1, 2, 11, 15, 4]],
    ['Адиль У.', '🇸🇪 Швеция', [1, 0, 3, 9, 13, 3]],
    ['Сабит И.', '🇩🇿 Алжир', [0, 1, 3, 2, 15, 1]],
  ]},
];

/* ---- расписание · каждый с каждым · s: счёт или null, t: тур, rest: кто отдыхает ---- */
export const FC_FIXTURES = [
  { g: 'A', matches: [
    { t: 1, a: 'Арман К.', b: 'Аркат А.', s: '3:0' },
    { t: 1, a: 'Улан Р.', b: 'Кузьма А.', s: '5:0', rest: 'Канат' },
    { t: 2, a: 'Канат', b: 'Аркат А.', s: '7:0' },
    { t: 2, a: 'Улан Р.', b: 'Арман К.', s: '6:3', rest: 'Кузьма А.' },
    { t: 3, a: 'Канат', b: 'Кузьма А.', s: '5:1' },
    { t: 3, a: 'Аркат А.', b: 'Улан Р.', s: '1:1', rest: 'Арман К.' },
    { t: 4, a: 'Улан Р.', b: 'Канат', s: '3:6' },
    { t: 4, a: 'Арман К.', b: 'Кузьма А.', s: '2:1', rest: 'Аркат А.' },
    { t: 5, a: 'Арман К.', b: 'Канат', s: '4:3' },
    { t: 5, a: 'Кузьма А.', b: 'Аркат А.', s: '3:0', rest: 'Улан Р.' },
  ]},
  { g: 'B', matches: [
    { t: 1, a: 'Евгений Г.', b: 'Мурат Д.', s: '0:3' },
    { t: 1, a: 'Кизат А.', b: 'Сын Алмаз', s: '7:0', rest: 'Егор П.' },
    { t: 2, a: 'Евгений Г.', b: 'Егор П.', s: '0:3' },
    { t: 2, a: 'Мурат Д.', b: 'Кизат А.', s: '6:2', rest: 'Сын Алмаз' },
    { t: 3, a: 'Сын Алмаз', b: 'Егор П.', s: '2:6' },
    { t: 3, a: 'Евгений Г.', b: 'Кизат А.', s: '0:3', rest: 'Мурат Д.' },
    { t: 4, a: 'Егор П.', b: 'Кизат А.', s: '1:0' },
    { t: 4, a: 'Сын Алмаз', b: 'Мурат Д.', s: '3:7', rest: 'Евгений Г.' },
    { t: 5, a: 'Егор П.', b: 'Мурат Д.', s: '3:1' },
    { t: 5, a: 'Евгений Г.', b: 'Сын Алмаз', s: '0:3', rest: 'Кизат А.' },
  ]},
  { g: 'C', matches: [
    { t: 1, a: 'Малик А.', b: 'Максим Ш.', s: '8:0' },
    { t: 1, a: 'Тобыл К.', b: 'Артур А.', s: '2:1', rest: 'Ахат К.' },
    { t: 2, a: 'Ахат К.', b: 'Максим Ш.', s: '7:1' },
    { t: 2, a: 'Малик А.', b: 'Артур А.', s: '5:2', rest: 'Тобыл К.' },
    { t: 3, a: 'Ахат К.', b: 'Тобыл К.', s: '2:1' },
    { t: 3, a: 'Артур А.', b: 'Максим Ш.', s: '5:0', rest: 'Малик А.' },
    { t: 4, a: 'Артур А.', b: 'Ахат К.', s: '2:5' },
    { t: 4, a: 'Малик А.', b: 'Тобыл К.', s: '6:5', rest: 'Максим Ш.' },
    { t: 5, a: 'Ахат К.', b: 'Малик А.', s: '4:0' },
    { t: 5, a: 'Тобыл К.', b: 'Максим Ш.', s: '1:2', rest: 'Артур А.' },
  ]},
  { g: 'D', matches: [
    { t: 1, a: 'Нурсултан Б.', b: 'Магомед Д.', s: '1:3' },
    { t: 1, a: 'Сергей Ш.', b: 'Арлан', s: '2:2', rest: 'Алмаз З.' },
    { t: 2, a: 'Алмаз З.', b: 'Нурсултан Б.', s: '4:0' },
    { t: 2, a: 'Сергей Ш.', b: 'Магомед Д.', s: '0:1', rest: 'Арлан' },
    { t: 3, a: 'Алмаз З.', b: 'Арлан', s: '1:1' },
    { t: 3, a: 'Нурсултан Б.', b: 'Сергей Ш.', s: '1:1', rest: 'Магомед Д.' },
    { t: 4, a: 'Сергей Ш.', b: 'Алмаз З.', s: '1:3' },
    { t: 4, a: 'Арлан', b: 'Магомед Д.', s: '3:3', rest: 'Нурсултан Б.' },
    { t: 5, a: 'Алмаз З.', b: 'Магомед Д.', s: '2:2' },
    { t: 5, a: 'Арлан', b: 'Нурсултан Б.', s: null, rest: 'Сергей Ш.' },
  ]},
  { g: 'E', matches: [
    { t: 1, a: 'Александр К.', b: 'Ростислав Х. (GRIZZLY)', s: '7:2' },
    { t: 1, a: 'Игорь Д.', b: 'Жорик И.', s: '4:1', rest: 'Никита Л.' },
    { t: 2, a: 'Никита Л.', b: 'Ростислав Х. (GRIZZLY)', s: '6:2' },
    { t: 2, a: 'Александр К.', b: 'Игорь Д.', s: '4:3', rest: 'Жорик И.' },
    { t: 3, a: 'Никита Л.', b: 'Жорик И.', s: '7:1' },
    { t: 3, a: 'Игорь Д.', b: 'Ростислав Х. (GRIZZLY)', s: '4:1', rest: 'Александр К.' },
    { t: 4, a: 'Никита Л.', b: 'Игорь Д.', s: '3:2' },
    { t: 4, a: 'Александр К.', b: 'Жорик И.', s: '2:0', rest: 'Ростислав Х. (GRIZZLY)' },
    { t: 5, a: 'Никита Л.', b: 'Александр К.', s: '4:1' },
    { t: 5, a: 'Жорик И.', b: 'Ростислав Х. (GRIZZLY)', s: '2:0', rest: 'Игорь Д.' },
  ]},
  { g: 'F', matches: [
    { t: 1, a: 'Руслан Л.', b: 'Роман И.', s: '3:0' },
    { t: 1, a: 'Сергей Н.', b: 'Даниил И.', s: '3:3', rest: 'Арғын Ш.' },
    { t: 2, a: 'Арғын Ш.', b: 'Роман И.', s: '3:0' },
    { t: 2, a: 'Руслан Л.', b: 'Сергей Н.', s: '3:3', rest: 'Даниил И.' },
    { t: 3, a: 'Даниил И.', b: 'Арғын Ш.', s: '0:4' },
    { t: 3, a: 'Сергей Н.', b: 'Роман И.', s: '3:0', rest: 'Руслан Л.' },
    { t: 4, a: 'Сергей Н.', b: 'Арғын Ш.', s: '1:5' },
    { t: 4, a: 'Даниил И.', b: 'Руслан Л.', s: '1:1', rest: 'Роман И.' },
    { t: 5, a: 'Арғын Ш.', b: 'Руслан Л.', s: '1:1' },
    { t: 5, a: 'Даниил И.', b: 'Роман И.', s: '3:0', rest: 'Сергей Н.' },
  ]},
  { g: 'G', matches: [
    { t: 1, a: 'Виталий А.', b: 'Асет У.', s: '0:3' },
    { t: 1, a: 'Даниял А.', b: 'Бек И.', s: '4:3', rest: 'Нурым К.' },
    { t: 2, a: 'Нурым К.', b: 'Виталий А.', s: '3:0' },
    { t: 2, a: 'Асет У.', b: 'Бек И.', s: '2:0', rest: 'Даниял А.' },
    { t: 3, a: 'Нурым К.', b: 'Даниял А.', s: '6:1' },
    { t: 3, a: 'Бек И.', b: 'Виталий А.', s: '3:0', rest: 'Асет У.' },
    { t: 4, a: 'Нурым К.', b: 'Бек И.', s: '1:0' },
    { t: 4, a: 'Асет У.', b: 'Даниял А.', s: '2:0', rest: 'Виталий А.' },
    { t: 5, a: 'Асет У.', b: 'Нурым К.', s: '6:1' },
    { t: 5, a: 'Виталий А.', b: 'Даниял А.', s: '0:3', rest: 'Бек И.' },
  ]},
  { g: 'H', matches: [
    { t: 1, a: 'Адиль У.', b: 'Нурсултан К.', s: '1:5' },
    { t: 1, a: 'Алдияр Ш.', b: 'Сабит И.', s: '2:2', rest: 'Влад А.' },
    { t: 2, a: 'Влад А.', b: 'Адиль У.', s: '4:2' },
    { t: 2, a: 'Алдияр Ш.', b: 'Нурсултан К.', s: '3:4', rest: 'Сабит И.' },
    { t: 3, a: 'Влад А.', b: 'Сабит И.', s: '7:0' },
    { t: 3, a: 'Алдияр Ш.', b: 'Адиль У.', s: '4:3', rest: 'Нурсултан К.' },
    { t: 4, a: 'Влад А.', b: 'Алдияр Ш.', s: '6:2' },
    { t: 4, a: 'Нурсултан К.', b: 'Сабит И.', s: '3:0', rest: 'Адиль У.' },
    { t: 5, a: 'Нурсултан К.', b: 'Влад А.', s: '3:3' },
    { t: 5, a: 'Адиль У.', b: 'Сабит И.', s: '3:0', rest: 'Алдияр Ш.' },
  ]},
];

/* ---- плей-офф · side: {n,c,via,g,win} известен · {ph} — плейсхолдер ---- */
export const FC_R16 = [
  { id: 'М1', time: 'В1 · СТОЛ 1', status: 'done', a: { n: 'Канат', c: 'Португалия', via: '1-е · A', g: 3 }, b: { n: 'Мурат Д.', c: 'Шотландия', via: '2-е · B', g: 4, win: true } },
  { id: 'М2', time: 'В1 · СТОЛ 2', status: 'done', a: { n: 'Ахат К.', c: 'Гана', via: '1-е · C', g: 4, win: true }, b: { n: 'Магомед Д.', c: 'Кот-д’Ивуар', via: '2-е · D', g: 1 } },
  { id: 'М3', time: 'В1 · СТОЛ 3', status: 'done', a: { n: 'Никита Л.', c: 'Австрия', via: '1-е · E', g: 7, win: true }, b: { n: 'Руслан Л.', c: 'Франция', via: '2-е · F', g: 0 } },
  { id: 'М4', time: 'В1 · СТОЛ 4', status: 'done', a: { n: 'Асет У.', c: 'Иордания', via: '1-е · G', g: 0 }, b: { n: 'Нурсултан К.', c: 'Юж. Корея', via: '2-е · H', g: 5, win: true } },
  { id: 'М5', time: 'В2 · СТОЛ 1', status: 'done', a: { n: 'Егор П.', c: 'Панама', via: '1-е · B', g: 1 }, b: { n: 'Арман К.', c: 'Египет', via: '2-е · A', g: 2, win: true } },
  { id: 'М6', time: 'В2 · СТОЛ 2', status: 'done', a: { n: 'Алмаз З.', c: 'Колумбия', via: '1-е · D', g: 4 }, b: { n: 'Малик А.', c: 'Испания', via: '2-е · C', g: 5, win: true } },
  { id: 'М7', time: 'В2 · СТОЛ 3', status: 'done', a: { n: 'Арғын Ш.', c: 'Кабо-Верде', via: '1-е · F', g: 6, win: true }, b: { n: 'Александр К.', c: 'Япония', via: '2-е · E', g: 5 } },
  { id: 'М8', time: 'В2 · СТОЛ 4', status: 'done', a: { n: 'Влад А.', c: 'Босния', via: '1-е · H', g: 9, win: true }, b: { n: 'Нурым К.', c: 'Гаити', via: '2-е · G', g: 2 } },
];
export const FC_QF = [
  { id: 'М9', time: '12 ИЮЛ', status: 'done', a: { n: 'Мурат Д.', c: 'Шотландия', via: 'М1', g: 4, win: true }, b: { n: 'Ахат К.', c: 'Гана', via: 'М2', g: 3 } },
  { id: 'М10', time: '12 ИЮЛ', status: 'done', a: { n: 'Никита Л.', c: 'Австрия', via: 'М3', g: 1 }, b: { n: 'Нурсултан К.', c: 'Юж. Корея', via: 'М4', g: 5, win: true } },
  { id: 'М11', time: '12 ИЮЛ', status: 'done', a: { n: 'Арман К.', c: 'Египет', via: 'М5', g: 9, win: true }, b: { n: 'Малик А.', c: 'Испания', via: 'М6', g: 4 } },
  { id: 'М12', time: '12 ИЮЛ', status: 'done', a: { n: 'Арғын Ш.', c: 'Кабо-Верде', via: 'М7', g: 4 }, b: { n: 'Влад А.', c: 'Босния', via: 'М8', g: 5, win: true } },
];
export const FC_SF = [
  { id: 'М13', time: '12 ИЮЛ', status: 'done', a: { n: 'Мурат Д.', c: 'Шотландия', via: 'М9', g: 2 }, b: { n: 'Нурсултан К.', c: 'Юж. Корея', via: 'М10', g: 3, win: true } },
  { id: 'М14', time: '12 ИЮЛ', status: 'done', a: { n: 'Арман К.', c: 'Египет', via: 'М11', g: 2 }, b: { n: 'Влад А.', c: 'Босния', via: 'М12', g: 4, win: true } },
];
export const FC_FINAL = { id: 'М16', label: 'ФИНАЛ · BO3', time: '12 ИЮЛ', status: 'done', a: { n: 'Нурсултан К.', c: 'Юж. Корея', via: 'М13', g: 3 }, b: { n: 'Влад А.', c: 'Босния', via: 'М14', g: 4, win: true } };
export const FC_THIRD = { id: 'М15', label: 'ЗА 3 МЕСТО', time: '12 ИЮЛ', status: 'done', a: { n: 'Мурат Д.', c: 'Шотландия', via: 'М13', g: 1 }, b: { n: 'Арман К.', c: 'Египет', via: 'М14', g: 4, win: true } };

export const FC_PLAYOFF_ROUNDS = [
  { key: 'r16', title: '1/8 ФИНАЛА', date: '12 ИЮЛ', matches: FC_R16 },
  { key: 'qf', title: '1/4 ФИНАЛА', date: '12 ИЮЛ', matches: FC_QF },
  { key: 'sf', title: 'ПОЛУФИНАЛЫ', date: '12 ИЮЛ · LAN', matches: FC_SF },
];

/* ---- FUT-карточки фаворитов · появятся по ходу турнира ---- */
export const FC_FEATURED = [];

/* ---- эфир · расписание на 12 июля ---- */
export const FC_STREAM = {
  liveTitle: 'FIFA OPEN · СКО — 12 июля',
  schedule: [
    { t: '12:00', x: 'Жеребьёвка, открытие и групповой этап · столы 1–4' },
    { t: '15:00', x: 'Плей-офф · 1/8 и 1/4 финала' },
    { t: '18:00', x: 'Полуфиналы, матч за 3 место и финал BO3' },
  ],
  vods: [],
};
